<section>
  <div class="form-register border">
    <form novalidate [formGroup]="formTransferWorkshopStoreDetail">
      <div class="row p-1">
        <div class="col-lg-2 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [labelText]="'Bodega'" [value]="codeNameStore" [required]="true"
            [disabled]="true"></app-custom-input-text>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [labelText]="'Artículo'" [value]="codeNameArticle" [required]="true"
            [disabled]="true"></app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [value]="stockArticle" [labelText]="'Existencias'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"
            [required]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="costValue" [labelText]="'Costo'"
            [required]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12 d-flex">
          <div class="d-flex align-items-end justify-content-end gap-2">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>